import React, { useState } from "react";
import { User } from "../helpers/interfaces.tsx";
import { API_BASE_URL } from "../../config.tsx";
import apiFetch from "../helpers/requests";
import { useTranslation } from "react-i18next";

type ConfirmDeleteUserModalProps = {
  setShowConfirmDeleteUserModal: React.Dispatch<React.SetStateAction<boolean>>;
  user: User;
  handleDeleteUser: () => void;
};

const ConfirmDeleteUserModal: React.FC<ConfirmDeleteUserModalProps> = ({
  setShowConfirmDeleteUserModal,
  user,
  handleDeleteUser,
}) => {
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const deleteUser = async (userId: string | null) => {
    try {
      const userData = await apiFetch(`/deleteUser`, {
        method: "POST",
        body: JSON.stringify({ userId }),
      });
      return userData;
    } catch (error) {
      console.error("Error delete user:", error);
      throw new Error("An error occurred while delete user");
    }
  };

  const handleDeleteUserClick = async (userId: string | null) => {
    setIsLoading(true);
    try {
      await deleteUser(userId);
      handleDeleteUser();
    } catch (error) {
      setIsLoading(false);
    }
  };

  return (
    <div className="confirmation-modal">
      <div className="modal-content">
        <div
          style={{ textAlign: "center", fontSize: "1.3em", marginTop: "2vh" }}
        >
          {t("Confirm_to_delete_user")}
        </div>
        <label style={{ lineHeight: "1", marginTop: "2vh" }}>
          {t("This_is_irreversible_action.")}
        </label>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "5vh",
            maxHeight: "1%",
          }}
        >
          <img
            src="/images/Icon_User_Simple.png"
            style={{
              width: "3vh",
              minWidth: "15px",
              marginRight: "1vh",
            }}
          />
          <div className="userDataWrapper">
            <div className="userDataName">
              {user.firstName + " " + user.lastName}
            </div>
            <div className="userDataEmail">{user.email}</div>
          </div>
        </div>

        <div className="button-container">
          <button
            type="button"
            className="buttonCancel btn btn-primary"
            disabled={isLoading}
            onClick={() => setShowConfirmDeleteUserModal(false)}
          >
            {t("Cancel")}
          </button>
          <button
            type="button"
            className="buttonAccept btn btn-primary"
            disabled={isLoading}
            onClick={() => handleDeleteUserClick(user.id)}
          >
            {isLoading ? t("Loading...") : t("Delete_User")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteUserModal;
